import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-referral-decline-img',
  templateUrl: './referral-decline-img.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ReferralDeclineImgComponent {
  @Input() done: boolean;
}
